import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M36 20C36 21.0231 35.1769 21.8462 34.1538 21.8462H5.84615C4.82308 21.8462 4 21.0231 4 20C4 18.9769 4.82308 18.1539 5.84615 18.1539H34.1538C35.1769 18.1539 36 18.9769 36 20Z" })
});
export default SvgMinus;
